export { default as CultureReportInfoTip } from "./CultureReportInfoTip";
